<template>
    <PageSidebar :showError="v$.$error">
        <template #sidebarTitle> {{ $t("love.menu.wall_of_love") }} </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <FormInput id="wallTitle" :title="$t('shared.title')" v-model="wall.wallTitle" />

                <FormInput
                    id="wallSubtitle"
                    :title="$t('shared.subtitle')"
                    v-model="wall.wallSubtitle"
                    @blur="v$.wall.wallSubtitle.$touch"
                    :error="v$.wall.wallSubtitle.$errors?.[0]?.$message"
                />

                <FormVariants
                    :title="$t('love.wall.view_type')"
                    :variants="layouts"
                    v-model="wall.layout"
                />

                <FormInput
                    v-if="
                        wall.layout === WALL_LAYOUTS.board ||
                        wall.layout === WALL_LAYOUTS.multislider
                    "
                    placeholder="20"
                    :title="$t('love.wall.max_testimonials')"
                    pattern="numeric"
                    v-model="wall.maxTestimonials"
                />

                <FormToggleSm
                    v-if="wall.layout === WALL_LAYOUTS.avatars"
                    :title="$t('love.wall.only_with_avatar')"
                    v-model="wall.showOnlyWithAvatar"
                />

                <FormInput
                    v-if="wall.layout === WALL_LAYOUTS.board"
                    :title="$t('love.wall.min_width')"
                    v-model="wall.width"
                />

                <FormToggleSm
                    v-if="wall.layout !== WALL_LAYOUTS.avatars"
                    :title="$t('love.wall.show_avatar')"
                    :modelValue="!wall.hideAvatar"
                    @update:modelValue="wall.hideAvatar = !$event"
                />

                <FormToggleSm
                    :title="$t('love.wall.show_stars')"
                    :modelValue="!wall.hideStars"
                    @update:modelValue="wall.hideStars = !$event"
                />

                <FormToggleSm
                    :title="$t('love.wall.show_position_www')"
                    :modelValue="!wall.hidePositionAndWww"
                    @update:modelValue="wall.hidePositionAndWww = !$event"
                />

                <FormToggleSm :title="$t('love.wall.show_footer')" v-model="wall.showFooter" />

                <FormToggleSm
                    :title="$t('love.wall.show_create_link')"
                    v-model="wall.showCreateLink"
                />
            </div>
        </template>
        <template #sidebarFooter>
            <cErrorInfo v-if="v$.$error" />
            <cSaveButton @save="handleFormSave" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import { FormInput, FormToggleSm, FormVariants } from "@easy/ui/forms";
import cErrorInfo from "@/shared/components/cErrorInfo.vue";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";
import { maxLength } from "@/shared/utils/forms/i18n-vuelidators";
import { useFormValidation } from "@/shared/utils/forms/useFormValidation";
import { WALL_LAYOUTS } from "@/apps/love/services/walls.service";
import { useLoveCreatorStore } from "@/apps/love/project/onboarding/love-creator.store";
import { storeToRefs } from "pinia";

export default {
    name: "SidebarWall",
    setup() {
        const loveCreatorStore = useLoveCreatorStore();
        const { layouts } = storeToRefs(loveCreatorStore);
        const { v$, validateForm } = useFormValidation();
        // --
        useFocusOnQueryField();

        return {
            v$,
            validateForm,
            WALL_LAYOUTS,
            layouts,
        };
    },
    validations() {
        const rules = {
            wall: {
                wallSubtitle: { maxLength: maxLength(255) },
            },
        };
        return rules;
    },
    components: {
        FormInput,
        FormToggleSm,
        FormVariants,
        PageSidebar,
        cErrorInfo,
        cSaveButton,
    },
    computed: {
        ...mapState("love", ["wall", "hasChanges"]),
    },
    methods: {
        ...mapActions("love/projects", ["saveSnapshot"]),
        async handleFormSave() {
            const isFormCorrect = await this.validateForm();

            if (isFormCorrect) {
                this.saveSnapshot();
            }
        },
    },
};
</script>
